import script from "./entry.vue?vue&type=script&setup=true&lang=ts"
export * from "./entry.vue?vue&type=script&setup=true&lang=ts"

import "./entry.vue?vue&type=style&index=0&id=0fecb5de&lang=less&scoped=true"
import "./entry.vue?vue&type=style&index=1&id=0fecb5de&lang=less"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fecb5de"]])

export default __exports__